import { ContextAction } from '../types';
import type { NavItemsAction, NavItemsState } from './types';

export const navItemsInitial = [];

export const navItemsReducer = (
  state: NavItemsState = [],
  action: NavItemsAction
): NavItemsState => {
  switch (action.type) {
    case ContextAction.setNavItems:
      return [...state, ...action.payload];
    default:
      return state;
  }
};
